import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Які дані ми збираємо',
    content: `Під час заповнення форми зворотного зв'язку ми збираємо наступні персональні дані:
• Ім'я
• Адреса електронної пошти (email)
• Номер телефону
• Текст повідомлення

Ми не збираємо дані автоматично, не використовуємо файли cookie для відстеження та не збираємо жодних інших даних без вашої явної згоди.`
  },
  {
    title: '2. Мета збору даних',
    content: `Ваші персональні дані використовуються виключно для:
• Відповіді на ваш запит або заявку на співпрацю
• Зв'язку з вами щодо умов та деталей співпраці
• Надання інформації про наші послуги

Ми не використовуємо ваші дані для маркетингових розсилок, реклами або продажу третім особам.`
  },
  {
    title: '3. Зберігання та захист даних',
    content: `Ваші дані зберігаються на захищених серверах. Ми вживаємо технічних та організаційних заходів для захисту персональних даних від несанкціонованого доступу, втрати або знищення.

Дані зберігаються лише протягом часу, необхідного для досягнення мети їх збору, або до вашого запиту на видалення.`
  },
  {
    title: '4. Передача даних третім особам',
    content: `Ми не продаємо, не передаємо та не розкриваємо ваші персональні дані третім особам, крім випадків:
• Коли це необхідно для виконання наших послуг (наприклад, платіжні системи)
• За вашою явною письмовою згодою
• На вимогу компетентних органів відповідно до законодавства України

Усі партнери та підрядники, які можуть мати доступ до даних, зобов'язані дотримуватися конфіденційності.`
  },
  {
    title: '5. Ваші права',
    content: `Відповідно до законодавства України про захист персональних даних, ви маєте право:
• Отримати доступ до своїх персональних даних
• Вимагати виправлення неточних даних
• Вимагати видалення ваших даних ("право на забуття")
• Відкликати згоду на обробку даних у будь-який момент
• Подати скаргу до уповноваженого органу з захисту персональних даних

Для реалізації будь-якого з цих прав зв'яжіться з нами через Telegram або email.`
  },
  {
    title: '6. Контактна інформація',
    content: `З питань, пов'язаних із захистом персональних даних, звертайтеся:

• Telegram: @bmg_managerrrr
• Email: info@bmgroup.ua
• Телефон: +38 (063) 412-04-90

Ми відповідаємо на запити щодо персональних даних протягом 5 робочих днів.`
  },
  {
    title: '7. Зміни до політики конфіденційності',
    content: `Ми залишаємо за собою право вносити зміни до цієї Політики конфіденційності. Про суттєві зміни ми повідомлятимемо через наші канали зв'язку. Продовження використання сайту після внесення змін означає вашу згоду з оновленою Політикою.

Дата останнього оновлення: квітень 2024 року.`
  }
];

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="py-16 relative overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(16,185,129,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(16,185,129,0.03)_1px,transparent_1px)] bg-[size:50px_50px]" />
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Політика конфіденційності
            </h1>
            <p className="text-gray-400 text-lg">
              Ми поважаємо вашу приватність і зобов'язуємося захищати ваші персональні дані
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-6">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8"
              >
                <h2 className="text-xl font-bold text-white mb-4">{section.title}</h2>
                <p className="text-gray-400 leading-relaxed whitespace-pre-line">{section.content}</p>
              </div>
            ))}

            <div className="text-center pt-4">
              <Link
                to="/"
                className="text-emerald-500 hover:text-emerald-400 transition-colors text-sm"
              >
                ← Повернутися на головну
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
